import { useEnhancedQuery } from '@/modules/common/application';
import { TenantInfoQuery } from '@/modules/common/types';

import { TENANT_INFO } from '../api/auth.query';

export const useTenantInfo = () => {
  const { refetch: fetchTenantInfo, loading: isFetchingTenantInfo } =
    useEnhancedQuery<TenantInfoQuery>(TENANT_INFO, {
      skip: true,
    });
  return { refetch: fetchTenantInfo, loading: isFetchingTenantInfo };
};
